import React, { useEffect, useState } from 'react';
import { Alert } from 'antd';

import UserStore from 'stores/UserStore';
import FormRequirements from 'components/OrderRequirements/Edit/';
import UIStore from '@/stores/UIStore';
import ContactSwitcher from 'components/ContactSwitcher/ContactSwitcher';
import Verify from '../../../components/Verify';

const ManageRequirements: React.FC = () => {
    useEffect(() => {
        UIStore.setSelectedKey(['order-requirements']);
        UIStore.setDocumentTitle('Account Defaults');
    }, []);

    if (!UserStore.isVerified) {
        return <Verify />;
    }

    return (
        <>
            <Alert
                showIcon={true}
                message="Please Note"
                description="These requirements affect cost and lead time. They will be present on Quotes and Orders by default per your
                input."
            />
            <FormRequirements contact_id={UserStore.user?.default_contact} />
        </>
    );
};

export default ManageRequirements;
